import type {
    StandardText,
    Sticker,
    PackingInstruction,
    BusinessTradingPartner,
    LockedField,
    OrderBffDeliveryPeriod,
} from '../../gql';

import { randNumber, randSentence, randWord, randMonth } from '@ngneat/falso';

import { FieldTypeEnum } from '../../gql';

// Helper function for delivery period mock data
const mockDeliveryPeriod = (
    overwrite?: Partial<OrderBffDeliveryPeriod>
): OrderBffDeliveryPeriod => ({
    deliveryPeriod: `${randMonth()} ${randNumber({ min: 2032, max: 2042 })}`,
    deliveryPeriodNumber: randNumber({ min: 9001, max: 9999 }),
    ...overwrite,
});

// Helper function for standard text mock data
const mockStandardText = (overwrite?: Partial<StandardText>): StandardText => ({
    isDeleted: false,
    standardText: randSentence(),
    standardTextNumber: randNumber({ min: 1000, max: 9999 }),
    textName: `${randWord({ capitalize: true })} Text`,
    ...overwrite,
});

// Helper function for sticker mock data
const mockSticker = (overwrite?: Partial<Sticker>): Sticker => ({
    isDeleted: false,
    stickerName: `${randWord({ capitalize: true })} Sticker`,
    stickerNumber: randNumber({ min: 100, max: 999 }),
    ...overwrite,
});

// Helper function for packing instruction mock data
const mockPackingInstruction = (
    overwrite?: Partial<PackingInstruction>
): PackingInstruction => ({
    isDeleted: false,
    packingInstruction: randSentence(),
    packingInstructionNumber: randNumber({ min: 1000, max: 9999 }).toString(),
    ...overwrite,
});

// Helper function for business trading partner mock data
const mockBusinessTradingPartner = (
    overwrite?: Partial<BusinessTradingPartner>
): BusinessTradingPartner => ({
    businessTradingPartnerName: `BTP ${randWord({ capitalize: true })}`,
    businessTradingPartnerNumber: randNumber({ min: 10000, max: 99999 }),
    isDeleted: false,
    ...overwrite,
});

// Helper function for locked field mock data
const mockLockedField = (overwrite?: Partial<LockedField>): LockedField => {
    const fieldTypes = Object.values(FieldTypeEnum);

    return {
        fieldName:
            fieldTypes[randNumber({ min: 0, max: fieldTypes.length - 1 })],
        lockReason: randSentence(),
        ...overwrite,
    };
};

export {
    mockDeliveryPeriod,
    mockStandardText,
    mockSticker,
    mockPackingInstruction,
    mockBusinessTradingPartner,
    mockLockedField,
};
